export default "__VITE_ASSET__BKy6JF2t__"